import { createToastInterface } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

export default defineNuxtPlugin((nuxtApp) => {
  const toast = createToastInterface({
    hideProgressBar: true,
    // Prevent adding duplicate toasts
    filterBeforeCreate: (toast, toasts) =>
      toasts.some((t) => t.type === toast.type && t.content === toast.content) ? false : toast,
  });

  nuxtApp.vueApp.use(toast);
  nuxtApp.provide('toast', toast);
});
